/**
 * 文字 视频路演 :公司简介、相关数据处理
*/

import { getStockInfo } from '../api/webhq';
import { getCampanyInfo } from '../apidata';

export default async function (mk: any, code: any) {
  // let json = await getCampanyInfo(code, mk);
  // let data = json?.result?.data;
  // if (data && data.length) { 
  //   $('#campany_sum').html(data[0].ORG_PROFILE)
  // }

  let mkstr = 'SZ';
  if (mk == 1) {
    mkstr = 'SH'
  };

  // 北交所
  if (mk == 0) {
    let stockinfo = await getStockInfo(mk, code);

    if (stockinfo.f111 == 81 && stockinfo.f181 & 2048) {
      mkstr = 'BJ'
    }
  }

  let mcode = mkstr + '' + code;

  //相关数据链接填充 
  //沪深
  if (mk == 0 || mk == 1) {
    let f10_url = `https://emweb.securities.eastmoney.com/pc_hsf10/pages/index.html?type=web&code=${mcode}&color=`

    $("#tab_cpbd").attr("href", `${f10_url}b#/cpbd`);//操盘必读
    $("#tab_gdjy").attr("href", `${f10_url}b#/gdyj`);//股东研究
    $("#tab_jyfx").attr("href", `${f10_url}b#/jyfx`);//经营分析
    $("#tab_gsgg").attr("href", `${f10_url}b#/zxgg`);//公司公告
    $("#tab_gsgk").attr("href", `${f10_url}b#/gsgk`);//公司概括
    $("#tab_cwfx").attr("href", `${f10_url}b#/cwfx`);//财务分析
    $("#tab_fhrz").attr("href", `${f10_url}b#/fhrz`);//分红融资
    $("#tab_gbjg").attr("href", `${f10_url}b#/gbjg`);//股本结构
    $("#tab_hyfx").attr("href", `${f10_url}b#/thbj`);//行业分析
    $("#tab_zbyz").attr("href", `${f10_url}b#/zbyz`);//资本运作
    $("#tab_glgg").attr("href", `${f10_url}b#/glgg`);//关联个股
    $("#tab_zjlx").attr("href", "http://data.eastmoney.com/zjlx/" + code + ".html");//资金流向
    $("#tab_lhbd").attr("href", "http://data.eastmoney.com/stock/lhb/" + code + ".html");//龙虎榜单
    $("#tab_jgpj").attr("href", "http://data.eastmoney.com/report/" + code + ".html");//机构评级
  };

  //美股 //http://emweb.eastmoney.com/pc_usf10/CoreReading/index?color=web&code=BABA
  if (mk == 105 || mk == 106 || mk == 107) {
    let f10_url = `https://emweb.eastmoney.com/PC_USF10/pages/index.html?code=${code}&type=web&color=`

    $("#tab_cpbd").attr("href", `${f10_url}w#/hxbd`);//操盘必读
    $("#tab_gdjy").attr("href", `${f10_url}w#/gbgd`);//股东研究
    $("#tab_jyfx").parent().hide();
    $("#tab_gsgg").parent().hide();
    $("#tab_gsgk").attr("href", `${f10_url}w#/gsgk`);//公司概括
    $("#tab_cwfx").attr("href", `${f10_url}w#/cwfx`);//财务分析
    $("#tab_fhrz").parent().hide();
    $("#tab_gbjg").parent().hide();
    $("#tab_hyfx").parent().hide();
    $("#tab_zbyz").parent().hide();
    $("#tab_glgg").parent().hide();
    // $("#tab_zjlx").attr("href", "http://data.eastmoney.com/zjlx/" + code + ".html");//资金流向
    // $("#tab_lhbd").attr("href", "http://data.eastmoney.com/stock/lhb/" + code + ".html");//龙虎榜单
    // $("#tab_jgpj").attr("href", "http://data.eastmoney.com/report/" + code + ".html");//机构评级
    $("#tab_zjlx").parent().hide();
    $("#tab_lhbd").parent().hide();
    $("#tab_jgpj").parent().hide();
  }

  //港股//http://emweb.securities.eastmoney.com/PC_HKF10/CoreReading/index?type=web&code=00700&color=b
  if (mk == 116) {
    let f10_url = `https://emweb.securities.eastmoney.com/PC_HKF10/pages/home/index.html?code=${code}&type=web&color=`

    $("#tab_cpbd").attr("href", `${f10_url}w#/CoreReading`);//操盘必读
    $("#tab_gdjy").attr("href", `${f10_url}w#/MajorShareholder`);//股东研究
    $("#tab_jyfx").parent().hide();
    $("#tab_gsgg").attr("href", `${f10_url}w#/CompanyNews`);//公司公告
    $("#tab_gsgk").attr("href", `${f10_url}w#/CompanyProfile`);//公司概括
    $("#tab_cwfx").attr("href", `${f10_url}w#/NewFinancialAnalysis`);//财务分析
    $("#tab_fhrz").parent().hide();
    $("#tab_gbjg").attr("href", `${f10_url}w#/CapitalStructure`);//股本结构
    $("#tab_hyfx").attr("href", `${f10_url}w#/IndustryComparison`);//行业分析
    $("#tab_zbyz").parent().hide();
    $("#tab_glgg").parent().hide();
    // $("#tab_zjlx").attr("href", "http://data.eastmoney.com/zjlx/" + code + ".html");//资金流向
    // $("#tab_lhbd").attr("href", "http://data.eastmoney.com/stock/lhb/" + code + ".html");//龙虎榜单
    // $("#tab_jgpj").attr("href", "http://data.eastmoney.com/report/" + code + ".html");//机构评级
    $("#tab_zjlx").parent().hide();
    $("#tab_lhbd").parent().hide();
    $("#tab_jgpj").parent().hide();
  }
}